import Vue from 'vue'

export default {
    log: (title = null, type = null) => {
        if (window.clicky) {
            window.clicky.log(window.location.pathname, title, type);
        }
    },
    goal: (id, revenue = null) => {
        if (window.clicky) {
            window.clicky.goal(id, revenue);
        }
    }
}